/**
 * Tiny wrapper around navigator.vibrate. Silent no-op when unsupported or denied.
 */
type HapticKind = 'tap' | 'place' | 'delete' | 'error';

export function haptic(kind: HapticKind): void {
  if (typeof navigator === 'undefined' || !navigator.vibrate) return;
  try {
    switch (kind) {
      case 'tap':    navigator.vibrate(5); break;
      case 'place':  navigator.vibrate(12); break;
      case 'delete': navigator.vibrate([20, 30, 20]); break;
      case 'error':  navigator.vibrate([40, 30, 40]); break;
    }
  } catch { /* ignore */ }
}
